import names from '../actions/actionNames';
import initialState from '../initialState';
import { STATUS, calculateStatus } from '../../common/status';

const calculateActiveStatus = isActive =>
  isActive ? STATUS.ACTIVE : STATUS.INACTIVE;

const processUserStatus = (users, calcStatus, { userLogin, statusInfo }) => {
  return users.map(user => {
    if (user.login !== userLogin) return user;
    return Object.assign(
      {},
      {
        ...user,
        status: calcStatus(statusInfo)
      }
    );
  });
};

const userReducers = (state = initialState.users, action) => {
  switch (action.type) {
    case names.ACTIVATE_USER_SUCCESS:
      return processUserStatus(state, calculateActiveStatus, action);
    case names.INVITE_USER_SUCCESS:
      return processUserStatus(state, calculateStatus, action);
    case names.SET_BULK_REMOVAL_ORGANIZATION_LIST:
      return {
        ...state,
        bulkRemoveOrganizations: action.payload
      };
    case names.SET_BULK_REMOVAL_ROLE_LIST:
      return {
        ...state,
        bulkRemoveRoles: action.payload || []
      };
    default:
      return state;
  }
};

export default userReducers;
